export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6696.6acd4e03.jpg";